<template>
<div class="table">
  <table class="table__main">
    <thead>
      <tr>
        <th scope="col"
            v-for="row in rows"
            :key="row.field"
            :class="getAlignClasses(row)">
            {{row.label}}
        </th>
        <th v-if="showActions"></th>
      </tr>
    </thead>
    <tbody v-if="items.length">
      <tr v-for="item in items" :key="item.id">
        <td v-for="row in rows" :key="row.field"
          :class="getAlignClasses(row)">
          <slot :name="row.field" :item="item">{{item[row.field]}}</slot>
        </td>
        <td class="table__actions" v-if="showActions">
          <edit-button class="mb-1" type="button" v-if="showEdit" @click="$emit('edit', item)" title="Редактировать"></edit-button>
          <delete-button type="button" v-if="showArchive" @click="$emit('archive', item)"></delete-button>
        </td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td colspan="100%">{{notFoundText}}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script>
import customButton from './CustomButton';
import deleteButton from './DeleteButton';
import editButton from './EditButton';

  export default {
    components: {
      customButton,
      deleteButton,
      editButton
    },
    props: {
      rows: Array, //[{ field: 'id', label: '#ID', align: 'center' }, ...],
      items: Array,
      notFoundText: { type: String, default: 'Не найдены' },
      showEdit: { type: Boolean, default: true },
      showArchive: { type: Boolean, default: true }
    },
    data() {
      return {
        confirmDelete: false
      }
    },
    computed: {
      showActions: function () {
        return this.showEdit || this.showArchive;
      }
    },
    methods: {
      getAlignClasses(row) {
        return {
          'table__align-center': row.align === 'center',
          'table__align-right': row.align === 'right',
          'table__fixed-height': row.fixedHeight === true
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
@import './../../styles/variables.scss';
.table {
    display: block;
    width: 100%;
    overflow-x: auto;
    border-left: none;
    border-radius: 4px;
    font-size: 13px;
    box-shadow: 0px 5px 7px -1px rgba(0, 0, 0, 0.25);

   &__main {
      width: 100%;
      border-collapse: collapse;
    }

  &__align-center {
    text-align: center;
  }

  &__align-right {
    text-align: right;
  }

  &__fixed-height {
    display: block;
    max-height: 100px;
    max-width: 500px;
    overflow-y: auto;
  }

  &__header {
    height: 60px;
    border-bottom: 2px solid #edf0f2;
    border-left: 2px solid #edf0f2;
    background-color: #f7f7f8;

    th {
      padding-left: 5px;
      border-right: 2px solid #edf0f2;
      text-transform: uppercase;
      color: #37393f;
      background-color: #e8e8e8;
      font-size: 13px;

      &:nth-last-child(-n+2){
        border: none;
      }
    }


  }
  &__actions {
    position: relative;
    padding: 10px;
  }

}

tr {
    height: 60px;
    background-color: white;
    border-left: 2px solid white;
    transition: all 200ms;

    &:hover {
        border-left: 2px solid #3d3df3;
        background-color: $light-blue;
    }

    .dark & {
      background-color: $bg-grey;
      border-left: 2px solid $bg-grey;

      &:hover {
        border-left: 2px solid #3d3df3;
        background-color: $dark-text;
      }
    }
}

thead tr:first-child {
  background-color: inherit;
  border-left: 2px solid white;
  transition: none;

  &:hover {
    background-color: inherit;
  }

  .dark & {
    border-left: 2px solid $bg-black;

    &:hover {
      background-color: $bg-black;
    }
  }

}

tr:nth-child(even){
    background-color: #fafbfc;
    border-left: 2px solid #fafbfc;

    &:hover {
        border-left: 2px solid #3d3df3;
        background-color: $light-blue;
    }

    .dark & {
      background-color:  $bg-black;
      border-left: 2px solid $bg-black;

      &:hover {
        border-left: 2px solid #3d3df3;
        background-color: $dark-text;
      }
    }
}

td {
    color: #37393f;
    line-height: 1.5;

    .dark & {
      color: $dark-grey;
    }
}
</style>